<div class="avatar" [ngStyle]="{'height': size, 'width': size}">
    <img class="avatar-img" *ngIf="optimizedProfileImgURL" [src]="optimizedProfileImgURL">
    <app-svg-loader *ngIf="!optimizedProfileImgURL" [height]="iconSize" url="assets/svg/user-solid.svg"></app-svg-loader>
</div>